import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form } from "antd";
import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus,
    submitForm
} from "utilities/form";
import CompanyService from "services/company-service";
import { GSTINDataRenderer } from "components";
import { INPUT_TYPES, COMPANY_TYPES,
    // RESIDENCE_TYPES 
} from "constants/index";
import { CASE_LEAD_TYPES, CASE_PRIORITY_TYPES, 
    // ADDRESSES_TYPES 
} from "constants/enums";
import { GSTIN_REGEX } from "constants/regex";
// import moment from "moment";
import { List } from "immutable";

const FORM_FIELDS = (
    GSTINvalidatorRule,
    onProductSelect,
    onAnchorSelect,
    getChannelProducts
) =>
    new OrderedMap({
        product: {
            className: "form-field fb-20",
            label: "Product",
            type: INPUT_TYPES.OBJECT_SELECT,
            getOptionsOnFocus: CompanyService.getProducts,
            labelProp: "name",
            onSelect: onProductSelect
        },
        gstin: {
            className: "form-field fb-20",
            label: "GSTIN",
            type: INPUT_TYPES.TEXT,
            placeholder: "29ABCDE1234F2Z2",
            hasFeedback: true,
            rules: [GSTINvalidatorRule]
        },
        // pan: {
        //     className: "form-field fb-20",
        //     label: "PAN",
        //     type: INPUT_TYPES.TEXT,
        //     placeholder: "29ABCDE1234F2Z2",
        //     hasFeedback: true,
        //     // rules: [GSTINvalidatorRule]
        // },
        ledger_name: {
            className: "form-field fb-20",
            label: "Ledger Name",
            type: INPUT_TYPES.TEXT,
            // rules: [
            //     {
            //         required: true
            //     }
            // ]
        },
        company_name: {
            className: "form-field fb-20",
            label: "Company Legal Name",
            type: INPUT_TYPES.TEXT,
            rules: [
                {
                    required: true
                }
            ]
        },
        seller: {
            className: "form-field fb-20",
            label: "Seller",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            labelProp: "name",
            notFoundContent: "This Seller doesn't exist, you need to create it.",
        },
        anchor: {
            className: "form-field fb-20",
            label: "Anchor",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            labelProp: "name",
            onAnchorSelect
        },
        channel_products: {
            className: "form-field fb-20",
            label: "Channel Products",
            type: INPUT_TYPES.OBJECT_SELECT,
            rules: [
                {
                    required: true
                }
            ],
            labelProp: "name",
            mode: "multiple",
            getOptionsOnFocus: getChannelProducts
        },
        bank: {
            className: "form-field fb-20",
            label: "Lending Partner",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            getOptionsOnFocus: CompanyService.getLendingPartners,
            labelProp: "name"
        },
        priority: {
            className: "form-field fb-20",
            label: "Priority",
            type: INPUT_TYPES.SELECT,
            options: CASE_PRIORITY_TYPES.map((_,k) => ({
                label: k,
                value: _
            })).toList(),
        },
        lead_type: {
            className: "form-field fb-20",
            label: "Lead Type",
            type: INPUT_TYPES.SELECT,
            options: CASE_LEAD_TYPES.map((_,k) => ({
                label: k,
                value: _
            })).toList(),
        },
        ledger_sync: {
            label: "Is Ledger Sync",
            className: "form-field fb-20",
            type: INPUT_TYPES.RADIO,
            defaultValue: false,
            options: [
                {
                    key: "Yes",
                    value: true,
                    label: "Yes"
                },
                {
                    key: "No",
                    value: false,
                    label: "No"
                }
            ]
        },
        proposed_limit: {
            className: "form-field fb-20",
            label: "Proposed Limit",
            type: INPUT_TYPES.FLOAT,
            // rules: [
            //     {
            //         required: true
            //     }
            // ]
        },
        sales_manager_user_id: {
            className: "form-field fb-20",
            label: "Sales Manager User",
            type: INPUT_TYPES.SELECT,
            // getOptionsOnFocus: CompanyService.getSMList,
            // labelProp: "full_name",
            rules: [
                {
                    required: true,
                    message: "Field Required"
                }
            ]
        },
        ledger_file: {
            className: "form-field fb-20",
            label: "Ledger",
            btnLabel: "Upload Ledger",
            showUploadList: false,
            type: INPUT_TYPES.FILE
        },
    });

class AddCaseForm extends React.Component {
    state = {
        sales_manager_users: null
    };
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    submitForm = submitForm.bind(this.props.form, values => {
        this.props.onSubmit(
            this.props.values.merge({
                values
            })
        );
    });
    componentDidMount() {
        CompanyService.getSMList().then(({data}) => {
            this.setState({
                sales_manager_users: data
            });
        });
    }
    componentDidUpdate(prevProps) {
        if(prevProps.values.gstin && !this.props.values.gstin) {
            this.gstin = null;
        }
    }
    gstin = null;
    gstinCustomValidator = {
        validator: (rule, value, callback) => {
            if(!value){
                return callback();
            }
            if (value.length === 15 && !GSTIN_REGEX.test(value) || value.length !== 15 && value.length>0) {
                return callback("Invalid GSTIN");
            }

            if (this.gstin && this.gstin.gstin === value) {
                this.props.form.setFieldsValue({
                    company_name: this.gstin.tradeNam
                });
                callback();
                return;
            }
            if (value && value.length > 0 && GSTIN_REGEX.test(value)) {
                CompanyService.parseGSTIN(value).then(({ data }) => {
                    if (!data || Object.keys(data).length === 0) {
                        callback("Not Found");
                        return;
                    }
                    this.gstin = data;
                    this.props.form.setFieldsValue({
                        company_name: this.gstin.tradeNam
                    });
                    callback();
                });
            }
        }
    };
    onProductSelect = product => {
        if (product.id === 1) {
            this.formFields = this.formFields
                .setIn(["seller", "disabled"], true)
                .setIn(["seller", "rules"], [])
                .setIn(["anchor", "disabled"], true)
                .setIn(["anchor", "rules"], [])
                .setIn(
                    ["ledger_file", "rules"],
                    [
                        {
                            required: false
                        }
                    ]
                );
            return;
        }
        if (product.id === 2) {
            this.formFields = this.formFields
                .setIn(["anchor", "disabled"], false)
                .setIn(
                    ["anchor", "rules"],
                    [
                        {
                            required: true
                        }
                    ]
                )
                .setIn(["anchor", "onSearch"], () =>
                    CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"))
                )
                .setIn(["seller", "disabled"], true)
                .setIn(["seller", "rules"], [])
                .setIn(
                    ["ledger_file", "rules"],
                    [
                        {
                            required: false
                        }
                    ]
                );
            return;
        }
        if (product.id === 3) {
            this.formFields = this.formFields.setIn(["seller", "disabled"], true).setIn(["seller", "rules"], [])
                .setIn(["anchor", "disabled"], false).setIn(["anchor", "onSearch"], () => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor")));

        }
        if (product.id === 4 || product.id === 5) {
            this.formFields = this.formFields
                .setIn(["anchor", "disabled"], false)
                .setIn(
                    ["anchor", "rules"],
                    [
                        {
                            required: true
                        }
                    ]
                )
                .setIn(["anchor", "onSearch"], () =>
                    CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"))
                )
                .setIn(["seller", "disabled"], false)
                .setIn(
                    ["seller", "rules"],
                    [
                        {
                            required: true
                        }
                    ]
                )
                .setIn(["seller", "onSearch"], () =>
                    CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Distributor"))
                );
        }
    };

    onAnchorSelect = anchor => {
        this.anchor_id = anchor.id;
    };
    getChannelProducts = () =>
        CompanyService.getChannelProducts(this.anchor_id);
    formFields = FORM_FIELDS(
        this.gstinCustomValidator,
        this.onProductSelect,
        this.onAnchorSelect,
        this.getChannelProducts
    );
    render() {
        return (
            <Form
                layout={"horizontal"}
                hideRequireMark={true}
                className={cx("form", "br-3")}
                onSubmit={this.submitForm}
            >
                <div className={"form-row align-items-center"}>
                    <React.Fragment>
                        {this.formFields
                            .map((field, fieldName) => {
                                if (fieldName === "sales_manager_user_id") {
                                    field.options = this.state.sales_manager_users && this.state.sales_manager_users.length ? new List(this.state.sales_manager_users.map((_) => ({
                                        label: _.full_name,
                                        value: _.id
                                    }))) : new List([]);
                                }
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )();
                            })
                            .toList()}
                        {/* {!this.gstin ? ADDRESS_FIELDS.map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )()
                        )
                            .toList() : null} */}
                        <div style={{ flexBasis: "100%" }}>
                            <GSTINDataRenderer data={this.gstin} />
                        </div>
                    </React.Fragment>
                </div>
            </Form>
        );
    }
}

AddCaseForm.propTypes = {
    form: PropTypes.object,
    onSubmit: PropTypes.func,
    values: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values, errors }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) =>
                    Form.createFormField({
                        value,
                        errors: errors && errors.size && errors.flatten().get(key) ? errors.flatten().get(key) : null 
                    })
                )
                .toJS()
        );
    }
})(AddCaseForm);
